<template>
  <div class="tab_ty2" id="tabs">
    <ul class="tab-menu">
      <li v-for="(tab, index) in tabs" v-bind:class="{active:currentTab===index}" :key="index">
        <button type="button" v-on:click="changeBoardTab(index)">{{tab}}</button>
      </li>
    </ul>
    <div class="tab-content">
      <BoardList ref="boardList" v-show="currentTab == 0" @addPrivateBoard="addPrivateBoard"/>
      <BoardKanban ref="boardKanban" v-show="currentTab == 1"/>
    </div>
  </div>
</template>

<script>
import BoardList from "./BoardList";
import BoardKanban from "./BoardKanban";

export default {
  name: 'tabs',
  components: {
    BoardList,
    BoardKanban,
  },
  data() {
    return {
      groupId:'',
      currentTab: 0,
      tabs: [this.$i18nUtil.trans("title.Private.tab.001.list","리스트"), this.$i18nUtil.trans("title.Private.tab.001.kanban","칸반")],

      // 뒤로가기
      prevBtn: false,
    };
  },
  methods: {
    addPrivateBoard(_data) {
      this.$emit("addPrivateBoard", _data);
    },
    initGroupId(groupId, prevBtn, currentTab){
      this.groupId = groupId;
      this.prevBtn = prevBtn;
      this.changeBoardTab(currentTab);
    },
    changeBoardTab(index){
      let obj = this; 

      let state = {
        currentTab: 0,
        currentTab2: index,
        currentTab3: 0, 
      };
      if (this.prevBtn) {
        //뒤로가기로 접근.
        let stateArr = JSON.parse(window.sessionStorage.getItem("private")) || [];
        // state = this.prevState;
        window.sessionStorage.setItem("prevBtn", this.prevBtn);
        if (stateArr.length != 0) {
          history.pushState(state, document.title, location.href);
        }
        this.prevBtn = false;
      }else{
        let stateArr = JSON.parse(window.sessionStorage.getItem("private")) || [];
        let lastState = [];
        if (stateArr.length != 0) {
          lastState = stateArr[stateArr.length - 1];
          if ( 
            lastState.currentTab != 0 ||
            lastState.currentTab2 != index ||
            lastState.currentTab3 != 0
          ) {
            // state = lastState;
            history.pushState(state, document.title, location.href);
          }
        }
      }

      if(index === 0) {
        //list
        this.$refs.boardList.initBoardList(this.groupId ,state);
      } else if(index === 1) {
        //kanban 
         this.$refs.boardKanban.initBoardKanban(this.groupId, state);
      }

      obj.currentTab = index;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/mypage/private/tab/board/BoardTab.vue